export default function Footer() {
  return (
    <footer className="doc-foot">
      <div className="foot-inner">
        <span>© 2026 EngiMind — 図面・計算・ノウハウの属人化をAIで解消（製造業・建設業）</span>
        <span className="mono">SHEET 1 / 1　SCALE — NTS</span>
      </div>
    </footer>
  );
}
